import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProjectSettingsResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectsComponentsResource } from '@jira/router-resources__projects-components/src/projectsComponentsResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectGlobalComponentsResource } from '@jira/router-resources__project-global-components/src/projectGlobalComponentsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsComponentsRoute } from '@jira/router-routes__projects-settings-components-routes/src/projectSettingsComponentsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import SettingsComponents, { LazyProjectComponentsSettings } from './ui/index.tsx';

export const projectSettingsComponentsRouteEntry: Route = createEntry(
	projectSettingsComponentsRoute,
	() => ({
		group: 'components',

		resources: [
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			projectContextResource,
			projectsComponentsResource,
			getConsolidationStateResource(),
			projectGlobalComponentsResource,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: SettingsComponents,
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		forPaint: [LazyAtlassianNavigation, LazyProjectComponentsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
